exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delivery-address-attention[data-v-d421901c] {\n  margin-bottom: 2.34%;\n}\n", ""]);
